module.exports = __webpack_public_path__ + "static/media/j.ebfde93d.gif";